import { render, staticRenderFns } from "./openingBankSelector.vue?vue&type=template&id=2f4c57b0"
import script from "./openingBankSelector.vue?vue&type=script&lang=js"
export * from "./openingBankSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports